module.exports = __webpack_public_path__ + "static/media/ben-logo-header-m.95a6321e.svg";